import red from "@material-ui/core/colors/red";

const styles = theme => ({
    item: { padding: 3 },
    paper: {
        overflow: "visible"
    },

    card: {
        overflow: "visible",
        display: "flex",
        maxHeight: 171,
        marginTop: 60
    },
    details: {
        display: "flex",
        flexDirection: "column"
    },
    content: {
        flex: "1 0 auto",
        textAlign: "center",
        marginTop: 24,
        transform: "translate(0,-100px)"
    },
    cover: {
        width: 151,
        height: 151,
        margin: 12,

        transform: "translate(0,-36px)"
    },
    icon: {
        width: "auto"
    },
    cardTop: {
        position: "relative",
        width: "100%" - 24,
        margin: 0,
        marginLeft: 12,
        marginRight: 12,
        marginBottom: 20,
        color: "#fff",
        borderRadius: 6,
        padding: 24,
        textAlign: "center"
    },
    controls: {
        display: "flex",
        alignItems: "center",
        paddingLeft: theme.spacing.unit,
        paddingBottom: theme.spacing.unit
    },
    playIcon: {
        height: 38,
        width: 38
    },
    avatar: {
        backgroundColor: red[500]
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: "90%"
    },
    TableCell: {
        textAlign: "left",
        "&:hover": {
            backgroundColor: "#eee"
        }
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2
    },
    table: {
        width: "inherit",
        padding: 0,
        margin: 0,
        display: "inline-block"
    },

    col4: { width: "33%" },
    barchart: {
        width: "98%",
        minHeight: 350,
        padding: 0,
        margin: 14,

        display: "inline-block"
    },
    barchartitem: {
        minHeight: 140
    },
    colRed: {
        backgroundColor: "#d12121",
        boxShadow:
            "0 1px 1px rgba(209,33,33,0.15), 0 10px 0 -5px rgba(209,33,33,0.15), 0 10px 1px -4px rgba(209,33,33,0.15), 0 20px 0 -10px rgba(209,33,33,0.15), 0 20px 1px -9px rgba(209,33,33,0.15)"
    },
    colBlue: {
        backgroundColor: "#056dc5",
        boxShadow:
            "0 1px 1px rgba(5,109,197,0.15), 0 10px 0 -5px rgba(5,109,197,0.15), 0 10px 1px -4px rgba(5,109,197,0.15), 0 20px 0 -10px rgba(5,109,197,0.15), 0 20px 1px -9px rgba(5,109,197,0.15)"
    },
    colGreen: {
        backgroundColor: "#74cc0d",
        boxShadow:
            "0 1px 1px rgba(116,204,13,0.15), 0 10px 0 -5px rgba(116,204,13,0.15), 0 10px 1px -4px rgba(116,204,13,0.15), 0 20px 0 -10px rgba(116,204,13,0.15), 0 20px 1px -9px rgba(116,204,13,0.15)"
    },
    colOrange: {
        backgroundColor: "#d16721",
        boxShadow:
            "0 1px 1px rgba(209,103,33,0.15), 0 10px 0 -5px rgba(209,103,33,0.15), 0 10px 1px -4px rgba(209,103,33,0.15), 0 20px 0 -10px rgba(209,103,33,0.15), 0 20px 1px -9px rgba(209,103,33,0.15)"
    }
});

export default styles;
